var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkDisable = function SvgIconLinkDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.043 17.14 1.605-1.605-2.408-2.408a4.163 4.163 0 0 1 5.887-5.887l2.408 2.408 1.606-1.605-2.409-2.409a6.433 6.433 0 0 0-9.098 9.098zM24.633 6.972l-4.281 4.282 4.014 4.014a6.433 6.433 0 1 1-9.098 9.098l-2.409-2.409 1.606-1.605 2.408 2.408a4.163 4.163 0 0 0 5.887-5.887l-4.014-4.014L6.972 24.633a1.135 1.135 0 1 1-1.605-1.605l17.66-17.661a1.135 1.135 0 1 1 1.606 1.605"
  })));
};
export default SvgIconLinkDisable;